import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_4 = { class: "overflow-x-auto" }
const _hoisted_5 = { class: "align-middle inline-block min-w-full" }
const _hoisted_6 = { class: "border overflow-hidden border-b border-gray-200 rounded-md" }
const _hoisted_7 = { class: "table-fixed min-w-full divide-y divide-gray-200" }
const _hoisted_8 = { class: "bg-gray-50" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-3 text-left text-xs font-medium text-gray-500 border-r"
}, " Contract ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", {
  width: "220px",
  scope: "col",
  class: "relative px-4 py-3 text-center text-xs font-medium text-gray-500 border-l"
}, "Reported / Allocated", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  width: "75px",
  style: {"min-width":"75px"},
  class: "px-1 py-3 text-center text-xs font-medium text-gray-500 border-l"
}, "Valid 25", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  width: "85px",
  style: {"min-width":"85px"},
  class: "px-1 py-3 text-center text-xs font-medium text-gray-500 border-l"
}, "Valid EOM", -1)
const _hoisted_13 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_14 = { class: "px-2 py-3 whitespace-nowrap border-r" }
const _hoisted_15 = { class: "flex align-middle justify-between items-center" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 1,
  class: "px-2 py-1"
}
const _hoisted_19 = { class: "mx-1" }
const _hoisted_20 = {
  title: "Contract Type",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_21 = {
  key: 0,
  title: "Measure Unit",
  class: "mx-1 text-xs font-semibold text-center p-1 uppercase rounded-md text-indigo-600 bg-indigo-100"
}
const _hoisted_22 = {
  key: 0,
  class: "w-4 h-4"
}
const _hoisted_23 = {
  key: 1,
  style: {"margin-top":"-2px"}
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"14px"} }, "?", -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 3,
  class: "w-4 h-4"
}
const _hoisted_30 = { class: "px-3 py-4 whitespace-nowrap text-left text-sm font-medium border-l" }
const _hoisted_31 = { class: "px-1 py-3 whitespace-nowrap text-center text-sm font-medium border-l" }
const _hoisted_32 = { class: "h-5 w-5 mr-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "25", -1)
const _hoisted_34 = { class: "px-1 py-3 whitespace-nowrap text-center text-sm font-medium border-l" }
const _hoisted_35 = { class: "h-5 w-5 mr-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, "EOM", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_report_progress = _resolveComponent("report-progress")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading "))
    : (_ctx.contracts.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No contracts to show. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _createElementVNode("thead", _hoisted_8, [
                    _createElementVNode("tr", null, [
                      _hoisted_9,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: day.date,
                          class: _normalizeClass(["text-center text-xs font-medium text-gray-500 uppercase", _ctx.getDateBgClass(day)])
                        }, _toDisplayString(index + 1), 3))
                      }), 128)),
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contracts, (monthReportContract) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: monthReportContract.contract.id,
                        class: "hover:bg-gray-50"
                      }, [
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, [
                              (_ctx.activeMode)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.$emit('openMonthModal', monthReportContract.contract)),
                                    class: "px-2 py-1 rounded-md text-blue-600 hover:bg-indigo-100 hover:text-blue-700"
                                  }, _toDisplayString(monthReportContract.contract.person.surname) + " " + _toDisplayString(monthReportContract.contract.person.name), 9, _hoisted_17))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(monthReportContract.contract.person.surname) + " " + _toDisplayString(monthReportContract.contract.person.name), 1))
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(monthReportContract.contract.contractType.id), 1),
                              (_ctx.showMeasureUnit)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(monthReportContract.contract.measureUnit.id) + _toDisplayString(monthReportContract.contract.measureUnitLabel ? `: ${monthReportContract.contract.measureUnitLabel}` : ''), 1))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: day.date,
                            class: _normalizeClass(_ctx.getDateBgClass(day))
                          }, [
                            ((day.holiday || day.weekend) && _ctx.isBlankDay(monthReportContract.days[index]))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  (_ctx.isEmptyDay(monthReportContract.days[index]))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.$emit('openDateModal', monthReportContract.contract, day.date)),
                                        class: _normalizeClass(["m-auto align-text-bottom rounded-full w-4 h-4 bg-red-200 border border-red-300 text-red-600", _ctx.activeMode ? 'hover:bg-red-400 hover:border-red-500' : 'cursor-default'])
                                      }, [
                                        _createVNode(_component_XIcon, {
                                          class: "h-3 w-3",
                                          style: {"margin-left":"1px"}
                                        })
                                      ], 10, _hoisted_24))
                                    : (_ctx.isPartialDay(monthReportContract.days[index]))
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.$emit('openDateModal', monthReportContract.contract, day.date)),
                                          class: _normalizeClass(["m-auto align-text-bottom rounded-full w-4 h-4 bg-yellow-200 border border-yellow-300 text-yellow-600 text-xs", _ctx.activeMode ? 'hover:bg-yellow-400 hover:border-yellow-500' : 'cursor-default'])
                                        }, _hoisted_27, 10, _hoisted_25))
                                      : (_ctx.isCompleteDay(monthReportContract.days[index]))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 2,
                                            onClick: ($event: any) => (_ctx.$emit('openDateModal', monthReportContract.contract, day.date)),
                                            class: _normalizeClass(["m-auto align-text-bottom rounded-full w-4 h-4 bg-green-200 border border-green-300 text-green-600", _ctx.activeMode ? 'hover:bg-green-400 hover:border-green-500' : 'cursor-default'])
                                          }, [
                                            _createVNode(_component_CheckIcon, {
                                              class: "h-3 w-3",
                                              style: {"margin-left":"1px"}
                                            })
                                          ], 10, _hoisted_28))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_29))
                                ]))
                          ], 2))
                        }), 128)),
                        _createElementVNode("td", _hoisted_30, [
                          _createVNode(_component_report_progress, {
                            reportedTime: monthReportContract.reportedTime,
                            allocatedTime: monthReportContract.allocatedTime
                          }, null, 8, ["reportedTime", "allocatedTime"])
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          (monthReportContract.valid25 != undefined)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["inline-flex items-center justify-center text-xs font-semibold text-center p-1 uppercase rounded-md", monthReportContract.valid25 ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100'])
                              }, [
                                _createElementVNode("span", _hoisted_32, [
                                  (monthReportContract.valid25)
                                    ? (_openBlock(), _createBlock(_component_CheckIcon, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_XIcon, { key: 1 }))
                                ]),
                                _hoisted_33
                              ], 2))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_34, [
                          (monthReportContract.validEOM != undefined)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["inline-flex items-center justify-center text-xs font-semibold text-center p-1 uppercase rounded-md", monthReportContract.validEOM ? 'text-green-600 bg-green-100' : 'text-red-600 bg-red-100'])
                              }, [
                                _createElementVNode("span", _hoisted_35, [
                                  (monthReportContract.validEOM)
                                    ? (_openBlock(), _createBlock(_component_CheckIcon, { key: 0 }))
                                    : (_openBlock(), _createBlock(_component_XIcon, { key: 1 }))
                                ]),
                                _hoisted_36
                              ], 2))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
}